(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/route-result/assets/javascripts/result-layout.js') >= 0) return;  svs.modules.push('/components/tipsen/route-result/assets/javascripts/result-layout.js');
"use strict";

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const _svs$components$tipse = svs.components.tipsen.routeResult,
  CalendarHolder = _svs$components$tipse.CalendarHolder,
  TableHolder = _svs$components$tipse.TableHolder,
  ResultDistribution = _svs$components$tipse.ResultDistribution,
  ResultDistributionFallback = _svs$components$tipse.ResultDistributionFallback,
  ResultCoupon = _svs$components$tipse.ResultCoupon,
  useFetchDate = _svs$components$tipse.useFetchDate,
  useSelectedResultDraw = _svs$components$tipse.useSelectedResultDraw,
  ResultSportkryss = _svs$components$tipse.ResultSportkryss,
  ResultNoDrawsAvailableFallback = _svs$components$tipse.ResultNoDrawsAvailableFallback,
  useCurrentDateDraws = _svs$components$tipse.useCurrentDateDraws;
const _svs$components$sport = svs.components.sport.drawsRedux.hooks,
  useDraw = _svs$components$sport.useDraw,
  useDrawSubscription = _svs$components$sport.useDrawSubscription;
const useDrawResults = svs.components.tipsen.hooks.useDrawResults;
const selectSportkryssFactors = svs.components.tipsen.engine.selectors.engineSelectors.selectSportkryssFactors;
const ErrorBoundary = svs.components.errorBoundary.ErrorBoundary;
const _ReactRedux = ReactRedux,
  useSelector = _ReactRedux.useSelector;
const WidgetContainer = svs.components.poolBetting.drawWidgets.WidgetContainer;
const DetailViewRouteResultHandler = svs.components.tipsen.detailViewRouteResultHandler.DetailViewRouteResultHandler;
const TemplateBrand = svs.components.tipsen.setBranding.TemplateBrand;
const TipsenModuleGameUrl = svs.components.sport.tipsenShared.TipsenModuleGameUrl;
const Paper = svs.ui.ReactPaper;
const _svs$components$lbUti = svs.components.lbUtils.useMediaQuery,
  useMediaQuery = _svs$components$lbUti.useMediaQuery,
  breakpoints = _svs$components$lbUti.breakpoints,
  BREAKPOINT_MD = _svs$components$lbUti.BREAKPOINT_MD;
const CenterToScreen = svs.components.tipsen.centerToScreen.CenterToScreen;
const useDrawErrorHandling = svs.components.tipsen.hooksWager.useDrawErrorHandling.useDrawErrorHandling;
const useDefinition = svs.components.tipsen.engine.utils.useDefinition;
const SportKryssErrorFallback = () => React.createElement("span", null, "N\xE5got gick fel. Vi kan inte visa resultat f\xF6r Sportkryss just nu.");
const ResultLayout = () => {
  var _drawResults$1$, _currentDateDraws$;
  const _useFetchDate = useFetchDate(),
    _useFetchDate2 = _slicedToArray(_useFetchDate, 4),
    _useFetchDate2$ = _useFetchDate2[0],
    year = _useFetchDate2$.year,
    month = _useFetchDate2$.month,
    currentDate = _useFetchDate2[1],
    hasDateParam = _useFetchDate2[2],
    noDrawsDateAvailable = _useFetchDate2[3];
  const _useCurrentDateDraws = useCurrentDateDraws(year, month, currentDate, hasDateParam),
    _useCurrentDateDraws2 = _slicedToArray(_useCurrentDateDraws, 2),
    currentDateDraws = _useCurrentDateDraws2[0],
    isLoadingFetchDate = _useCurrentDateDraws2[1];
  const _useSelectedResultDra = useSelectedResultDraw(currentDateDraws),
    _useSelectedResultDra2 = _slicedToArray(_useSelectedResultDra, 2),
    drawNumber = _useSelectedResultDra2[0],
    productId = _useSelectedResultDra2[1];

  useDrawSubscription(drawNumber, productId, {
    sendInitialUpdate: true
  });
  const definition = useDefinition();
  const shouldFetchJackpot = (definition === null || definition === void 0 ? void 0 : definition.hasJackpot) || false;
  const draw = useDraw({
    productId,
    drawNumber
  }, {
    shouldFetchJackpot
  });
  const _useDrawResults = useDrawResults({
      productId,
      drawNumber
    }),
    drawResults = _useDrawResults.data;
  const drawId = "".concat(productId, "_").concat(drawNumber);
  const isWideScreen = useMediaQuery(breakpoints.up(BREAKPOINT_MD));
  const errorDialog = {
    acceptText: 'Okej'
  };
  useDrawErrorHandling({
    drawNumber,
    productId,
    errorDialog,
    shouldRedirect: false
  });

  const sportkryssFactors = useSelector(selectSportkryssFactors);
  const shouldRenderSportkrysset = sportkryssFactors && (sportkryssFactors === null || sportkryssFactors === void 0 ? void 0 : sportkryssFactors.length) > 1;
  const _drawResults = _slicedToArray(drawResults, 4),
    drawIsCancelled = _drawResults[3];
  const resultDistributionLoading = !drawNumber && !productId;
  const shouldRenderResultDistribution = !drawIsCancelled && drawResults && drawResults[1] && drawResults[1][0] && ((_drawResults$1$ = drawResults[1][0]) === null || _drawResults$1$ === void 0 ? void 0 : _drawResults$1$.winDiv);
  return React.createElement(CenterToScreen, {
    className: "result-layout",
    isMainElem: true
  }, draw && React.createElement(TemplateBrand, {
    draw: draw,
    drawId: drawId
  }), React.createElement("div", {
    className: "calendar-holder"
  }, React.createElement(CalendarHolder, null)), noDrawsDateAvailable && !((_currentDateDraws$ = currentDateDraws[0]) !== null && _currentDateDraws$ !== void 0 && _currentDateDraws$.drawNumber) ? React.createElement(ResultNoDrawsAvailableFallback, null) : React.createElement("div", {
    className: "grid-row"
  }, React.createElement("div", {
    className: "col-md-".concat(isWideScreen ? 7 : 12)
  }, React.createElement(ResultCoupon, {
    currentDateDraws: currentDateDraws,
    draw: draw,
    drawResults: drawResults,
    isLoadingFetchDate: isLoadingFetchDate
  }), (resultDistributionLoading || shouldRenderResultDistribution) && React.createElement(TableHolder, {
    label: "Utdelning"
  }, React.createElement(Paper, {
    branding: "sport"
  }, shouldRenderResultDistribution ? React.createElement(ResultDistribution, {
    drawNumber: drawNumber,
    productId: productId
  }) : React.createElement(ResultDistributionFallback, null))), shouldRenderSportkrysset && React.createElement(ErrorBoundary, {
    fallback: SportKryssErrorFallback
  }, React.createElement(ResultSportkryss, {
    currentDateDraw: currentDateDraws[0],
    month: month,
    sportkryssFactors: sportkryssFactors,
    year: year
  })), React.createElement(WidgetContainer, {
    className: isWideScreen ? 'margin-right-half margin-left-1' : 'margin-right-1 margin-left-1',
    drawNumber: draw === null || draw === void 0 ? void 0 : draw.drawNumber,
    productId: draw === null || draw === void 0 ? void 0 : draw.productId
  })), draw && React.createElement("aside", {
    "aria-label": "Statistik",
    className: "pg_sticky_div__statistics col-md-5"
  }, React.createElement(DetailViewRouteResultHandler, {
    drawNumber: draw.drawNumber,
    menuItemPathsPrefix: "".concat(TipsenModuleGameUrl.RESULT, "/:date([0-9]{4}-[0-9]{2}-[0-9]{2})?"),
    productId: draw.productId
  }))));
};
setGlobal('svs.components.tipsen.routeResult.ResultLayout', ResultLayout);

 })(window);